export const getIntialValues = (data = {}) => {
  return {
    meta_seo: {
      meta_title: data?.meta_seo?.meta_title || "",
      meta_keyword: data?.meta_seo?.meta_keyword || "",
      meta_desc: data?.meta_seo?.meta_desc || "",
    },

    header: {
      heading: data?.header?.heading || "",
       alt_tag : data?.header?.alt_tag || "",
      description: data?.header?.description || "",
      banner: {
        mobile_url: data?.header?.banner?.mobile_url || "",
        desktop_url: data?.header?.banner?.desktop_url || "",
      },
    },
    section_empower: {
      heading: data?.section_empower?.heading || "",
      description: data?.section_empower?.description || "",
      educators: data?.section_empower?.educators?.length
        ? data.section_empower.educators
        : [
            {
              label: "",
              count: "",
              suffix:"",
              image_link: "",
              alt_tag:"",
            },
          ],
    },
    section_beleives: {
      heading: data?.section_beleives?.heading || "",
      believes: data?.section_beleives?.believes?.length
        ? data.section_beleives.believes
        : [
            {
              image_link: "",
              alt_tag:"",
              label: "",
              description: "",
            },
          ],
    },
    section_story: {
      heading: data?.section_story?.heading || "",
      alt_tag: data?.section_story?.alt_tag || "",
      description: data?.section_story?.description || "",
      banner: {
        mobile_url: data?.section_story?.banner?.mobile_url || "",
        desktop_url: data?.section_story?.banner?.desktop_url || "",
      },
    },
    testimonials: {
      heading: data?.testimonials?.heading || "",
      faq_heading:data?.testimonials?.faq_heading || "",
      testimonials: data?.testimonials?.testimonials || [{ faq: "" }],
    },
  };
};

export const generatePayload = (values) => {
  return {
    meta_seo: {
      meta_title: values?.meta_seo?.meta_title || "",
      meta_keyword: values?.meta_seo?.meta_keyword || "",
      meta_desc: values?.meta_seo?.meta_desc || "",
    },
    header: {
      heading: values?.header?.heading || "",
      alt_tag : values?.header?.alt_tag || "",
      description: values?.header?.description || "",
      banner: {
        mobile_url: values?.header?.banner?.mobile_url || "",
        desktop_url: values?.header?.banner?.desktop_url || "",
      },
    },
    section_empower: {
      heading: values?.section_empower?.heading || "",
      description: values?.section_empower?.description || "",
      educators: values?.section_empower?.educators?.length
        ? values.section_empower.educators
        : [
            {
              label: "",
              count: "",
              suffix:"",
              image_link: "",
               alt_tag:"",
            },
          ],
    },
    section_beleives: {
      heading: values?.section_beleives?.heading || "",
      believes: values?.section_beleives?.believes?.length
        ? values.section_beleives.believes
        : [
            {
              image_link: "",
              alt_tag:"",
              label: "",
              description: "",
            },
          ],
    },
    section_story: {
      heading: values?.section_story?.heading || "",
        alt_tag: values?.section_story?.alt_tag || "",
      description: values?.section_story?.description || "",
      banner: {
        mobile_url: values?.section_story?.banner?.mobile_url || "",
        desktop_url: values?.section_story?.banner?.desktop_url || "",
      },
    },
    testimonials: {
      heading: values?.testimonials?.heading || "",
      faq_heading:values?.testimonials?.faq_heading || "",
      testimonials: values?.testimonials?.testimonials || [{ faq: "" }],
    },
  };
};
